// extracted by mini-css-extract-plugin
module.exports = {"numInput":"DayMonthInput_numInput__N3HhD"};